import { AppNS } from 'app';
import {
  isAgency,
  isBackoffice,
  isClient,
  isInspector,
} from 'app/helpers/userRoles';
import { Params } from 'app/types';

import {
  getAgencyApps,
  getAgencyNavigation,
  getBackOfficeApps,
  getElevatorsAgencyNavigation,
} from './users-config/agency';
import {
  getBackofficeNavigation,
  getElevatorsBackOfficeNavigation,
} from './users-config/backoffice';
import {
  getClientNavigation,
  getClientsApps,
  getDcraClientNavigation,
  getElevatorsClientNavigation,
} from './users-config/client';
import { getInspectorNavigation } from './users-config/inspector';

export const getNavigationConfig = (
  user: AppNS.User,
  currentApp: string
): AppNS.NavigationElement[] => {
  if (isAgency(user)) {
    if (currentApp === 'elevators') {
      return getElevatorsAgencyNavigation(user);
    }
    return getAgencyNavigation(user);
  }

  if (isClient(user)) {
    if (currentApp === 'dcra-inspections') {
      return getDcraClientNavigation();
    }

    if (currentApp === 'elevators') {
      return getElevatorsClientNavigation();
    }
    return getClientNavigation(user);
  }

  if (isInspector(user)) {
    return getInspectorNavigation();
  }

  if (isBackoffice(user)) {
    if (currentApp === 'elevators') {
      return getElevatorsBackOfficeNavigation();
    }
    return getBackofficeNavigation();
  }

  return [];
};

export const getApps = (user: AppNS.User): Params[] => {
  if (isAgency(user)) {
    return getAgencyApps();
  }

  if (isClient(user)) {
    return getClientsApps();
  }

  if (isBackoffice(user)) {
    return getBackOfficeApps();
  }

  return [];
};
